import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CModal, CModalHeader, CAccordion, CAccordionItem, CModalBody, CAccordionBody, CAccordionHeader, CModalTitle, CModalFooter, CButton } from '@coreui/react';
import { CFormInput } from '@coreui/react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import monday from '../billingmanagement/caisiere/pictures/momo.png'; // Mobile money icon
import money from '../billingmanagement/caisiere/pictures/Money.png'; // Card payment icon
import { FaArrowLeft } from "react-icons/fa";
import api from '../../../service/caller';
import { getUserIdFromToken } from '../../../utils/authUtils';
import choco from '../../../assets/images/choco.png';
import Select from "react-select";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import {format} from 'date-fns'

const DoctorSelectionrdv = ({ visible, onClose }) => {
  const navigate = useNavigate();
  const [doctors, setDoctors] = useState([]);
  const [billingdata, setBillingdata] = useState([]);
  const [UserData, setUserData] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const [appointmentDate, setAppointmentDate] = useState(null);
  const [appointmentFinalInfo, setAppointmentFinalInfo] = useState(null);
  const [doctorMessage, setDoctorMessage] = useState('');
  const [doctorScheduleData, setDoctorScheduleData] = useState(null);
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [calendarView, setCalendarView] = useState('timeGridWeek');
  const calendarRef = useRef(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [specialties, setSpecialties] = useState([]);
  const [selectedSpecialty, setSelectedSpecialty] = useState(null);
  const [showAllDoctors, setShowAllDoctors] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [availableTimeSlots, setAvailableTimeSlots] = useState({});
  const [isLoadingAvailability, setIsLoadingAvailability] = useState(false);
  // Added state for appointment type selection
  const [appointmentType, setAppointmentType] = useState('inperson');

  const location = useLocation();
  const appointmentInfo = location.state;

  const hospitalId = appointmentInfo?.hospitalId;
  const departmentId = appointmentInfo?.appointmentData.department;
  const isEditing = appointmentInfo?.isEditing;
  const [showPenaltyWarningModal, setShowPenaltyWarningModal] = useState(false);
  const [penaltyAmount, setPenaltyAmount] = useState(0);
  const [systemSettings, setSystemSettings] = useState({
    modificationPenaltyPercentage: 15, // Valeur par défaut
    minimumModificationHours: 24 // Valeur par défaut
  });
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('mobile-money');
  const [phone, setPhoneNumber] = useState('');
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [cardNumber, setCardNumber] = useState('');
  const [cardExpiry, setCardExpiry] = useState('');
  const [cardCVC, setCardCVC] = useState('');

  const [selectedDoctor, setSelectedDoctor] = useState('');
  // Appointment type options
  const appointmentTypeOptions = [
    { value: 'inperson', label: 'In-person consultation' },
    { value: 'online', label: 'Video consultation' }
  ];

  // Fetch existing appointments for a doctor
  const fetchExistingAppointments = async (doctorId) => {
    try {
      const response = await api.get(`/api/appointments/doctor/${doctorId}`);
      console.log("esist", response.data)
      return response.data || [];
    } catch (error) {
      console.error('Erreur lors de la récupération des rendez-vous existants:', error);
      return [];
    }
  };

  // Check if a time slot is already booked
  const isTimeSlotBooked = (date, startTime, endTime, bookedSlots) => {
    return bookedSlots.some(slot => {
      // If different date, no conflict
      if (slot.date !== date) return false;

      // Convert hours to minutes for easier comparison
      const convertToMinutes = (timeStr) => {
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours * 60 + minutes;
      };

      const newStart = convertToMinutes(startTime);
      const newEnd = convertToMinutes(endTime);
      const existingStart = convertToMinutes(slot.startTime);
      const existingEnd = convertToMinutes(slot.endTime);

      // Check for overlap
      return (
        (newStart >= existingStart && newStart < existingEnd) || // New start is during existing slot
        (newEnd > existingStart && newEnd <= existingEnd) || // New end is during existing slot
        (newStart <= existingStart && newEnd >= existingEnd) // New slot completely encompasses existing slot
      );
    });
  };    // Récupération des départements

  useEffect(() => {
    const fetchSystemSettings = async () => {
      try {
        const response = await api.get('/clinic/system-settings');
        if (response.data) {
          setSystemSettings({
            modificationPenaltyPercentage: response.data.modificationPenaltyPercentage || 15,
            minimumModificationHours: response.data.minimumModificationHours || 24
          });
        }
      } catch (error) {
        console.error('Error fetching system settings:', error);
      }
    };

    fetchSystemSettings();
  }, []);
  useEffect(() => {
    if (!hospitalId) return;

    const fetchDepartments = async () => {
      try {
        const response = await api.get(`/api/departments/hospital/${hospitalId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        });
        setDepartments(response.data.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des départements:', error);
      }
    };

    fetchDepartments();
  }, [hospitalId]);

  // Récupération des infos utilisateur
  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
        setUserRole(response.data.role.name);
      } catch (error) {
        toast.error("Failed to fetch user data");
      }
    };
    fetchLoggedUserData();
  }, []);

  // Récupération des médecins par département
  const fetchDoctors = async () => {
    try {
      const response = await api.get(`/api/getDoctorsByDepartment/${departmentId}`);

      if (response.data && response.data.data) {
        setDoctors(response.data.data);
      } else {
        setDoctorMessage("Aucun médecin trouvé pour ce département.");
      }
    } catch (err) {
      console.error('Erreur lors du chargement des docteurs:', err);
      setDoctorMessage(`Erreur: ${err.message}`);
    }
  };

  useEffect(() => {
    if (departmentId) {
      fetchDoctors();
    }
  }, [departmentId]);


  // Fetch doctor schedule and extract specialties
  const fetchDoctorSchedule = async (doctorId) => {
    try {
      const response = await api.get(`/api/newschedule/${doctorId}`);
      console.log('Données du planning récupérées:', response.data);

      if (response.data && !response.data.message) {
        setDoctorScheduleData(response.data);

        // Extract specialties from schedule data
        const doctorSpecialties = extractSpecialtiesFromSchedule(response.data);
        setSpecialties(doctorSpecialties);

        // Reset selected specialty when doctor changes
        setSelectedSpecialty(null);
        setCalendarEvents([]);
      } else {
        console.log('Aucun planning trouvé pour ce médecin');
        setCalendarEvents([]);
        setSpecialties([]);
        toast.info("Aucun horaire disponible pour ce médecin");
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des horaires:', error);
      setCalendarEvents([]);
      setSpecialties([]);
      toast.error("Erreur lors du chargement des disponibilités");
    }
  };

  // Fonction pour gérer la confirmation de modification avec pénalité
  const handleConfirmModificationWithPenalty = async () => {
    // Fermer le modal d'avertissement de pénalité et ouvrir le modal de paiement
    setShowPenaltyWarningModal(false);
    const paymentData = {
      operationtype: 'Update appointment',
      OperationId: appointmentInfo?.appointmentData?._id,
      operationRef: "Appointment",
      operationcode: appointmentInfo?.appointmentData?.AppointmentCode,
      caissiereId: getUserIdFromToken(),
      patientId: appointmentInfo?.appointmentData?.patientId,
      amount: penaltyAmount,
      currency: 'FCFA',
      purpose: 'Consultation Fee',
      department: appointmentInfo?.appointmentData?.department,
      hospitalId: appointmentInfo?.appointmentData?.hospitalId
    };

    const paymentResponsed = await api.post('/clinic/createPayment', paymentData);
    const appointmentData = {
      doctorId: selectedEvent.doctorId,
      patientId: appointmentInfo.appointmentData.patientId,
      motif: appointmentInfo.appointmentData.motif,
      department: appointmentInfo.appointmentData.department,
      price: appointmentInfo.appointmentData.price,
      notes: appointmentInfo.appointmentData.notes,
      type_consultation: appointmentType,
      appointmentDate: selectedEvent.date,
      appointmentTime: selectedEvent.time,
      appointmentEndTime: selectedEvent.endTime,
      specialtyId: selectedEvent.specialtyId,
      specialtyName: selectedEvent.specialtyName
    }

    const dataAppointment = {
      hospitalId,
      appointmentData
    };
    const response = await api.put(`/clinic/updateappointments/${appointmentInfo.appointmentData._id}`, dataAppointment);
    console.log("Blazon",paymentResponsed)
    const billingID = paymentResponsed?.data?.billing?._id;
    navigate(`/Billings/invoiceAssurance/${billingID}`, {
        state: { billingID },
    });
  };

  // Fonction pour gérer la sélection de la méthode de paiement
  const handlePaymentMethodSelect = (method) => {
    setPaymentMethod(method);
  };

  // Fonction pour gérer la confirmation du paiement mobile money
  const handleMomoPaymentConfirmation = async () => {
    if (paymentMethod === 'mobile-money' && !phone) {
      toast.error('Veuillez entrer votre numéro de téléphone');
      return;
    }

    setIsProcessingPayment(true);

    try {
      // Appeler l'API de traitement des paiements
      const paymentResponse = await api.post(`/payment/paymentmomo/initiate`, {
        item_name: 'Modify appointment Payment',
        motifId: appointmentInfo?.appointmentData?._id,
        currency: 'USD',
        amount: penaltyAmount,
        paymentMethod: paymentMethod,
        payerMessage: "Modification fee",
        phoneNumber: phone,
        paymentReason: 'Modify appointment',
      });

      if (paymentResponse.status === 200) {
        // Paiement réussi, procéder à la modification
        const paymentData = {
          operationtype: 'Update appointment',
          OperationId: appointmentInfo?.appointmentData?._id,
          operationRef: "Appointment",
          operationcode: appointmentInfo?.appointmentData?.AppointmentCode,
          caissiereId: getUserIdFromToken(),
          patientId: appointmentInfo?.appointmentData?.patientId,
          amount: penaltyAmount,
          currency: 'FCFA',
          purpose: 'Consultation Fee',
          department: appointmentInfo?.appointmentData?.department,
          hospitalId: appointmentInfo?.appointmentData?.hospitalId
        };

        const paymentResponsed = await api.post('/clinic/createPayment', paymentData);

        setShowPaymentModal(false);
        const appointmentData = {
          doctorId: selectedEvent.doctorId,
          patientId: appointmentInfo.appointmentData.patientId,
          motif: appointmentInfo.appointmentData.motif,
          department: appointmentInfo.appointmentData.department,
          price: appointmentInfo.appointmentData.price,
          notes: appointmentInfo.appointmentData.notes,
          type_consultation: appointmentType,
          appointmentDate: selectedEvent.date,
          appointmentTime: selectedEvent.time,
          appointmentEndTime: selectedEvent.endTime,
          specialtyId: selectedEvent.specialtyId,
          specialtyName: selectedEvent.specialtyName
        }

        const dataAppointment = {
          hospitalId,
          appointmentData
        };
        const response = await api.put(`/clinic/updateappointments/${appointmentInfo.appointmentData._id}`, dataAppointment);
        // setAppointmentInfo(response.data.appointment);

        // Si le prix a changé, mettre à jour le paiement
        // if (appointmentData.price !== appointmentInfo?.appointmentData.price) {
        //     const paymentData = {
        //         OperationId: response.data.appointment._id,
        //         operationtype: 'Appointment Consultation Update',
        //         operationcode: response.data.appointment.AppointmentCode,
        //         paymentuniqueId: response.data.appointment.paymentuniqueId,
        //         caissiereId: getUserIdFromToken(),
        //         patientId: appointmentData.patientId,
        //         amount: appointmentData.price,
        //         currency: 'FCFA',
        //         purpose: 'Consultation Fee Update',
        //         department: appointmentData.department,
        //     };

        //     const paymentResponse = await api.post('/clinic/updatePayment', paymentData);
        //     const billingID = paymentResponse.data.billing._id;

        //     // Rediriger vers la facture si le patient est connecté
        //     if (userRole === "medtinz_client_patient" && billingID) {
        //         navigate(`/Billings/invoiceAssurance/${billingID}`, {
        //             state: { billingID },
        //         });
        //     } else {
        //         setShowSuccessModal(true);
        //     }
        // } else {
        setShowSuccessModal(true);
        toast.success("Rendez-vous mis à jour avec succès");
        // if (onAppointmentUpdated) {
        //     onAppointmentUpdated(response.data.appointment);
        // }
        // }
        toast.success('Paiement traité avec succès');
      } else {
        toast.error('Le traitement du paiement a échoué');
      }
    } catch (error) {
      console.error('Erreur lors du traitement du paiement:', error);
      toast.error('Le traitement du paiement a échoué: ' + (error.response?.data?.message || 'Erreur inconnue'));
    } finally {
      setIsProcessingPayment(false);
    }
  };

  const handleDateClick = (dateClickInfo) => {
    const clickedDate = dateClickInfo.dateStr;
    setSelectedDate(clickedDate);

    // Find the event for this date
    const event = calendarEvents.find(event =>
      new Date(event.start).toISOString().split('T')[0] === clickedDate
    );

    if (event && event.extendedProps && event.extendedProps.availableSlots) {
      // Group slots by doctor
      const slotsByDoctor = {};
      event.extendedProps.availableSlots.forEach(slot => {
        const doctorKey = `${slot.doctorLastname} ${slot.doctorFirstname}`;
        if (!slotsByDoctor[doctorKey]) {
          slotsByDoctor[doctorKey] = [];
        }
        slotsByDoctor[doctorKey].push(slot);
      });

      setAvailableTimeSlots(slotsByDoctor);
    } else {
      setAvailableTimeSlots({});
    }
  };

  // 5. Handle selection of a time slot
  const handleSlotSelection = (slot) => {
    setSelectedEvent({
      ...slot,
      // Keep existing properties and add:
      isEmergency: slot.type === 'emergency',
      isAlreadyBooked: slot.isAlreadyBooked || false
    });
  };

  const getAvailableSlotsForDoctor = (scheduleData, specialty, doctor, existingAppointments) => {
    if (!scheduleData || !scheduleData.template) return [];

    const availabilityData = [];
    const template = scheduleData.template;
    const currentDate = new Date();

    // Process existing appointments
    const bookedSlots = existingAppointments.map(appointment => ({
      date: new Date(appointment.appointmentDate).toISOString().split('T')[0],
      startTime: appointment.appointmentTime,
      endTime: appointment.appointmentEndTime || calculateEndTime(appointment.appointmentTime, 30),
      specialtyId: appointment.specialtyId
    }));

    // Day name to index mapping
    const dayMap = {
      'monday': 1, 'tuesday': 2, 'wednesday': 3, 'thursday': 4,
      'friday': 5, 'saturday': 6, 'sunday': 0
    };

    // Specialty duration
    const specialtyDuration = scheduleData.specialtyDurations?.[specialty.id] || 30;

    // 1. First process regular slots
    Object.entries(template).forEach(([dayName, dayData]) => {
      if (!dayData.active) return;
      if (!dayData.specialtyId || dayData.specialtyId._id !== specialty.id) return;

      const dayIndex = dayMap[dayName];
      const dayDiff = (dayIndex - currentDate.getDay() + 7) % 7;
      const allowDoubleBooking = dayData.allowDoubleBooking || false;

      // Calculate date for this day
      let date = new Date(currentDate);
      date.setDate(date.getDate() + dayDiff);

      // Generate slots for the next 40 weeks
      for (let week = 0; week < 40; week++) {
        const slotDate = new Date(date);
        slotDate.setDate(slotDate.getDate() + (week * 7));
        const slotDateStr = slotDate.toISOString().split('T')[0];

        // Skip past dates
        if (new Date(slotDateStr) < new Date().setHours(0, 0, 0, 0)) continue;

        // Calculate time slots
        const startTime = dayData.start || '09:00';
        const endTime = dayData.end || '17:00';

        const startDateTime = new Date(`${slotDateStr}T${startTime}`);
        const endDateTime = new Date(`${slotDateStr}T${endTime}`);

        let currentSlot = new Date(startDateTime);

        while (currentSlot < endDateTime) {
          const slotStart = new Date(currentSlot);
          const slotEnd = new Date(slotStart.getTime() + specialtyDuration * 60000);

          if (slotEnd <= endDateTime) {
            const slotStartTime = slotStart.toTimeString().substring(0, 5);
            const slotEndTime = slotEnd.toTimeString().substring(0, 5);

            const isSlotBooked = isTimeSlotBooked(
              slotDateStr,
              slotStartTime,
              slotEndTime,
              bookedSlots
            );

            // Check if slot is available based on booking rules
            const isSlotAvailable = !isSlotBooked ||
              (allowDoubleBooking && isSlotBooked &&
                (userRole === "medtinz_client_receptionnist" ||
                  userRole === "medtinz_client_doctor" ||
                  userRole === "medtinz_client_master"));

            if (isSlotAvailable) {
              availabilityData.push({
                doctorId: doctor._id,
                doctorFirstname: doctor.firstname,
                doctorLastname: doctor.lastname,
                date: slotDateStr,
                time: slotStartTime,
                endTime: slotEndTime,
                durationApt: specialtyDuration,
                specialtyId: specialty.id,
                specialtyName: dayData.specialtyId.name,
                allowDoubleBooking: allowDoubleBooking,
                isAlreadyBooked: isSlotBooked,
                type: 'regular'
              });
            }
          }

          currentSlot = slotEnd;
        }
      }
    });

    // 2. Now process emergency slots if they exist
    if (scheduleData.emergencySlots && scheduleData.emergencySlots.length > 0) {
      scheduleData.emergencySlots.forEach(emergencySlot => {
        // Fixed: Access the specialtyId correctly from emergencySlot
        if (emergencySlot.specialtyId && emergencySlot.specialtyId._id === specialty.id) {
          // Check if the emergency slot date is in the future
          const slotDate = new Date(emergencySlot.date);
          if (slotDate < new Date().setHours(0, 0, 0, 0)) return;

          const slotDateStr = slotDate.toISOString().split('T')[0];

          // Fixed: Use start/end instead of startTime/endTime
          const startTime = emergencySlot.start || '09:00';
          const endTime = emergencySlot.end || '17:00';

          // Calculate available time slots within the emergency slot period
          const startDateTime = new Date(`${slotDateStr}T${startTime}`);
          const endDateTime = new Date(`${slotDateStr}T${endTime}`);

          let currentSlot = new Date(startDateTime);
          // Default to specialty duration if no specific duration is set
          const slotDuration = emergencySlot.duration || specialtyDuration;

          while (currentSlot < endDateTime) {
            const slotStart = new Date(currentSlot);
            const slotEnd = new Date(slotStart.getTime() + slotDuration * 60000);

            if (slotEnd <= endDateTime) {
              const slotStartTime = slotStart.toTimeString().substring(0, 5);
              const slotEndTime = slotEnd.toTimeString().substring(0, 5);

              const isSlotBooked = isTimeSlotBooked(
                slotDateStr,
                slotStartTime,
                slotEndTime,
                bookedSlots
              );

              const isSlotAvailable = !isSlotBooked || emergencySlot.allowDoubleBooking;

              if (isSlotAvailable) {
                availabilityData.push({
                  doctorId: doctor._id,
                  doctorFirstname: doctor.firstname,
                  doctorLastname: doctor.lastname,
                  date: slotDateStr,
                  time: slotStartTime,
                  endTime: slotEndTime,
                  durationApt: slotDuration,
                  specialtyId: specialty.id,
                  specialtyName: emergencySlot.specialtyId.name,
                  allowDoubleBooking: emergencySlot.allowDoubleBooking || false,
                  isAlreadyBooked: isSlotBooked,
                  type: 'emergency',
                  isEmergency: true
                });
              }
            }

            currentSlot = slotEnd;
          }
        }
      });
    }

    return availabilityData;
  };

  const fetchAllDoctorsAvailability = async () => {
    if (isLoadingAvailability) return;
    try {
      setIsLoadingAvailability(true);
      const availableDates = new Map();

      // Process each doctor one by one
      for (const doctor of doctors) {
        const response = await api.get(`/api/newschedule/${doctor._id}`);
        if (!response.data || response.data.message) continue;

        const doctorScheduleData = response.data;
        const doctorSpecialties = extractSpecialtiesFromSchedule(doctorScheduleData);

        for (const specialty of doctorSpecialties) {
          // Get existing appointments for this doctor
          const existingAppointments = await fetchExistingAppointments(doctor._id);
          const availableSlots = getAvailableSlotsForDoctor(
            doctorScheduleData,
            specialty,
            doctor,
            existingAppointments
          );

          // Group slots by date
          availableSlots.forEach(slot => {
            const dateStr = slot.date;
            if (!availableDates.has(dateStr)) {
              availableDates.set(dateStr, []);
            }
            availableDates.get(dateStr).push(slot);
          });
        }
      }

      const events = generateAvailabilityEvents(
        availableDates, 
        true, 
        isEditing, 
        appointmentInfo.appointmentData.appointmentDate
      );

      setCalendarEvents(events);
      setIsLoadingAvailability(false);
    } catch (error) {
      console.error('Error fetching all doctors availability:', error);
      toast.error('Error loading availability data');
      setIsLoadingAvailability(false);
    }
  };

  const DoctorSelectionSection = () => (
    <div className="form-group mb-4">
      <label htmlFor="doctor">Doctor</label>
      <div className="d-flex align-items-center">
        <Select
          name="doctorId"
          options={doctors.map((doctor) => ({
            value: doctor._id,
            label: `${doctor.lastname} ${doctor.firstname}`
          }))}
          value={selectedDoctor ? { value: selectedDoctor._id, label: `${selectedDoctor.lastname} ${selectedDoctor.firstname}` } : null}
          onChange={(selectedOption) => {
            if (selectedOption) {
              const doctor = doctors.find(d => d._id === selectedOption.value);
              handleDoctorSelection(doctor);
              setShowAllDoctors(false);
            } else {
              setSelectedDoctor(null);
            }
          }}
          placeholder="Select a doctor"
          isClearable
          className="flex-grow-1 me-2"
        />
        <button
          type="button"
          className={`btn ${showAllDoctors ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => {
            setShowAllDoctors(true);
            setSelectedDoctor(null);
            fetchAllDoctorsAvailability();
          }}
        >
          All Doctors
        </button>
      </div>
    </div>

  );

  const CalendarComponent = () => (
    <div className="row">
      <div className={selectedDate ? "col-md-8" : "col-md-12"}>
        {/* Calendar legend */}
        <div className="mb-3 d-flex flex-wrap gap-3">
          <div className="d-flex align-items-center">
            <div style={{ width: '15px', height: '15px', backgroundColor: '#28a745', marginRight: '5px' }}></div>
            <small>Regular slots</small>
          </div>
          <div className="d-flex align-items-center">
            <div style={{ width: '15px', height: '15px', backgroundColor: '#dc3545', marginRight: '5px' }}></div>
            <small>Emergency slots</small>
          </div>
          <div className="d-flex align-items-center">
            <div style={{ width: '15px', height: '15px', backgroundColor: '#2979ff', marginRight: '5px' }}></div>
            <small>Double-bookable slots</small>
          </div>
        </div>

        <FullCalendar
          ref={calendarRef}
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          initialDate={selectedDate} // Cette valeur est définie sur la date du rendez-vous actuel en mode modification
          headerToolbar={{
            left: 'prev,next today',
            center: 'title',
            right: ''  
          }}
          events={calendarEvents}
          dateClick={handleDateClick}
          height="auto"
        />
      </div>

      {selectedDate && (
  <div className="col-md-4">
    <div className="card">
      <div className="card-header bg-primary text-white">
        Available Times for {new Date(selectedDate).toLocaleDateString()}
      </div>
      <div className="card-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {Object.keys(availableTimeSlots).length > 0 ? (
          Object.entries(availableTimeSlots).map(([doctorName, slots]) => (
            <div key={doctorName} className="mb-3">
              <h5>{doctorName}</h5>
              <div className="d-flex flex-wrap">
                {slots.map((slot, index) => {
                  // Vérifiez si ce créneau correspond au rendez-vous actuel
                  const isCurrentAppointment = 
                    isEditing && 
                    slot.date === appointmentInfo.appointmentData.appointmentDate && 
                    slot.time === appointmentInfo.appointmentData.appointmentTime;

                  return (
                    <button
                      key={index}
                      className={`btn btn-sm m-1 ${
                        selectedEvent &&
                        selectedEvent.time === slot.time &&
                        selectedEvent.doctorId === slot.doctorId
                          ? 'btn-primary'
                          : isCurrentAppointment
                          ? 'btn-warning' // Couleur jaune pour le créneau actuel
                          : slot.type === 'emergency'
                          ? 'btn-outline-danger'
                          : slot.isAlreadyBooked && slot.allowDoubleBooking
                          ? 'btn-outline-info'
                          : 'btn-outline-primary'
                      }`}
                      onClick={() => handleSlotSelection(slot)}
                      title={`${slot.specialtyName} ${slot.type === 'emergency' ? '(Emergency)' : ''} ${slot.isAlreadyBooked && slot.allowDoubleBooking ? '(Double-bookable)' : ''}`}
                    >
                      {slot.time}
                      {isCurrentAppointment && <span className="ms-1">⚡</span>} {/* Indicateur visuel */}
                    </button>
                  );
                })}
              </div>
            </div>
          ))
        ) : (
          <p>No available time slots for this date.</p>
        )}
        {(isEditing && (format( new Date (selectedDate), "yyyy-MM-dd") === format( new Date (appointmentInfo.appointmentData.appointmentDate), "yyyy-MM-dd") )) && (
          <button
            className={`btn btn-sm m-1 btn-warning`} disabled>
            {appointmentInfo.appointmentData.appointmentTime}
            {appointmentInfo.appointmentData.appointmentTime && <span className="ms-1">⚡</span>}
          </button>
        )}
      </div>
    </div>
  </div>
)}
    </div>
  );

  // Extract unique specialties from schedule data
  const extractSpecialtiesFromSchedule = (scheduleData) => {
    if (!scheduleData || !scheduleData.template) {
      return [];
    }

    const specialtiesMap = new Map();

    // Extract specialties from template days
    Object.values(scheduleData.template).forEach(day => {
      if (day.active && day.specialtyId) {
        specialtiesMap.set(day.specialtyId._id, {
          id: day.specialtyId._id,
          name: day.specialtyId.name,
          duration: scheduleData.specialtyDurations?.[day.specialtyId._id] || 30,
          hasEmergencySlots: false  // Default to false, will update if emergency slots found
        });
      }
    });

    // Extract specialties from emergency slots
    if (scheduleData.emergencySlots && scheduleData.emergencySlots.length > 0) {
      scheduleData.emergencySlots.forEach(slot => {
        if (slot.specialtyId) {
          const existingSpecialty = specialtiesMap.get(slot.specialtyId._id);

          if (existingSpecialty) {
            // Update existing specialty to mark emergency slots
            specialtiesMap.set(slot.specialtyId._id, {
              ...existingSpecialty,
              hasEmergencySlots: true
            });
          } else {
            // Add new specialty for emergency slot
            specialtiesMap.set(slot.specialtyId._id, {
              id: slot.specialtyId._id,
              name: slot.specialtyId.name,
              duration: scheduleData.specialtyDurations?.[slot.specialtyId._id] || 30,
              hasEmergencySlots: true
            });
          }
        }
      });
    }

    return Array.from(specialtiesMap.values());
  };

  useEffect(() => {
    if (selectedDoctor) {
      fetchDoctorSchedule(selectedDoctor._id);
    }
  }, [selectedDoctor]);


  const generateAvailabilityEvents = (availableDates, isAllDoctors = false) => {
    const events = [];

    availableDates.forEach((slots, dateStr) => {
      // Count regular and emergency slots
      const regularSlots = slots.filter(s => s.type === 'regular');
      const emergencySlots = slots.filter(s => s.type === 'emergency' || s.isEmergency);
      const doubleBookableSlots = slots.filter(s => s.isAlreadyBooked && s.allowDoubleBooking);

      // For all doctors view, show count of doctors
      if (isAllDoctors) {
        // Get unique doctors
        const doctorSet = new Set(slots.map(s => s.doctorId));

        // Create the event with more detailed title
        let title = `${doctorSet.size} doctor(s) available`;
        if (emergencySlots.length > 0) {
          title += ` (${emergencySlots.length} emergency slots)`;
        }
        if (doubleBookableSlots.length > 0) {
          title += ` (${doubleBookableSlots.length} double-bookable)`;
        }

        // Determine color based on slot types
        let color = '#28a745'; // Default green
        if (emergencySlots.length > 0) {
          color = '#dc3545'; // Red for emergency
        } else if (doubleBookableSlots.length > 0) {
          color = '#2979ff'; // Blue for double-bookable
        }

        events.push({
          title: title,
          start: dateStr,
          color: color,
          allDay: true,
          extendedProps: {
            availableSlots: slots,
            hasEmergencySlots: emergencySlots.length > 0,
            hasDoubleBookableSlots: doubleBookableSlots.length > 0
          }
        });
      }
      // For single doctor view
      else {
        const doctor = slots[0]; // Get the first slot to get doctor info

        // Create the event with more detailed title
        let title = `Dr. ${doctor.doctorLastname} ${doctor.doctorFirstname} available`;
        if (emergencySlots.length > 0) {
          title += ` (${emergencySlots.length} emergency slots)`;
        }
        if (doubleBookableSlots.length > 0) {
          title += ` (${doubleBookableSlots.length} double-bookable)`;
        }

        // Determine color based on slot types
        let color = '#28a745'; // Default green
        if (emergencySlots.length > 0) {
          color = '#dc3545'; // Red for emergency
        } else if (doubleBookableSlots.length > 0) {
          color = '#2979ff'; // Blue for double-bookable
        }

        events.push({
          title: title,
          start: dateStr,
          color: color,
          allDay: true,
          extendedProps: {
            availableSlots: slots,
            hasEmergencySlots: emergencySlots.length > 0,
            hasDoubleBookableSlots: doubleBookableSlots.length > 0
          }
        });
      }
    });

    if (isEditing && appointmentInfo.appointmentData.appointmentDate) {
      const exists = events.some(event => event.start === appointmentInfo.appointmentData.appointmentDate);
      if (!exists) {
        events.push({
          title: 'Current Appointment',
          start: appointmentInfo.appointmentData.appointmentDate,
          color: '#ffc107', // Couleur jaune pour le rendez-vous actuel
          allDay: true,
          extendedProps: {
            isCurrentAppointment: true
          }
        });
      }
    }

    return events;
  };
  // Generate calendar events from doctor schedule data for a specific specialty
  const generateCalendarEvents = async (scheduleData, specialtyId, doctorId) => {
    if (!scheduleData || !scheduleData.template) {
      setCalendarEvents([]);
      return;
    }

    const existingAppointments = await fetchExistingAppointments(doctorId);

    const events = [];
    const template = scheduleData.template;
    const currentDate = new Date();

    const bookedSlots = existingAppointments.map(appointment => ({
      date: new Date(appointment.appointmentDate).toISOString().split('T')[0],
      startTime: appointment.appointmentTime,
      endTime: appointment.appointmentEndTime || calculateEndTime(appointment.appointmentTime, 30),
      specialtyId: appointment.specialtyId
    }));

    const dayMap = {
      'monday': 1,
      'tuesday': 2,
      'wednesday': 3,
      'thursday': 4,
      'friday': 5,
      'saturday': 6,
      'sunday': 0
    };

    const specialtyDuration = scheduleData.specialtyDurations?.[specialtyId] || 30;

    Object.entries(template).forEach(([dayName, dayData]) => {
      if (!dayData.active) return;
      if (!dayData.specialtyId || dayData.specialtyId._id !== specialtyId) return;

      const dayIndex = dayMap[dayName];
      const dayDiff = (dayIndex - currentDate.getDay() + 7) % 7;
      const allowDoubleBooking = dayData.allowDoubleBooking || false;

      let date = new Date(currentDate);
      date.setDate(date.getDate() + dayDiff);

      for (let week = 0; week < 4; week++) {
        const slotDate = new Date(date);
        slotDate.setDate(slotDate.getDate() + (week * 7));
        const slotDateStr = slotDate.toISOString().split('T')[0];

        const startTime = dayData.start || '09:00';
        const endTime = dayData.end || '17:00';

        const startDateTime = new Date(`${slotDateStr}T${startTime}`);
        const endDateTime = new Date(`${slotDateStr}T${endTime}`);

        let currentSlot = new Date(startDateTime);

        while (currentSlot < endDateTime) {
          const slotStart = new Date(currentSlot);
          const slotEnd = new Date(slotStart.getTime() + specialtyDuration * 60000);

          if (slotEnd <= endDateTime) {
            const slotStartTime = slotStart.toTimeString().substring(0, 5);
            const slotEndTime = slotEnd.toTimeString().substring(0, 5);

            const isSlotBooked = isTimeSlotBooked(
              slotDateStr,
              slotStartTime,
              slotEndTime,
              bookedSlots
            );

            const isSlotAvailable = !isSlotBooked ||
              (allowDoubleBooking && isSlotBooked &&
                (userRole === "medtinz_client_receptionnist" ||
                  userRole === "medtinz_client_doctor" ||
                  userRole === "medtinz_client_master"));

            if (isSlotAvailable) {
              events.push({
                title: `${dayData.specialtyId.name} (${specialtyDuration} min)`,
                start: slotStart.toISOString(),
                end: slotEnd.toISOString(),
                color: (allowDoubleBooking && isSlotBooked) ? '#2979ff' : '#28a745',
                extendedProps: {
                  type: 'regular',
                  doctorId: doctorId,
                  date: slotDateStr,
                  time: slotStartTime,
                  durationApt: specialtyDuration,
                  specialtyId: specialtyId,
                  specialtyName: dayData.specialtyId.name,
                  allowDoubleBooking: allowDoubleBooking,
                  isAlreadyBooked: isSlotBooked
                }
              });
            }
          }

          currentSlot = slotEnd;
        }
      }
    });

    setCalendarEvents(events);
  };
  // Generate calendar events when specialty is selected
  // useEffect(() => {
  //   if (selectedSpecialty && doctorScheduleData && selectedDoctor) {
  //     (async () => {
  //       await generateCalendarEvents(doctorScheduleData, selectedSpecialty.id, selectedDoctor._id);
  //     })();
  //   }
  // }, [selectedSpecialty, doctorScheduleData, selectedDoctor]); // Remove generateCalendarEvents from dependencies

  const handleDoctorSelection = async (doctor) => {
    setSelectedDoctor(doctor);
    setSelectedEvent(null); // Reset selected event when doctor changes
    setSelectedSpecialty(null); // Reset selected specialty when doctor changes
    setShowAllDoctors(false);

    try {
      setIsLoadingAvailability(true);
      const availableDates = new Map();

      // Récupérer le planning du médecin sélectionné
      const response = await api.get(`/api/newschedule/${doctor._id}`);
      if (response.data && !response.data.message) {
        const doctorScheduleData = response.data;
        const doctorSpecialties = extractSpecialtiesFromSchedule(doctorScheduleData);

        // Pour chaque spécialité du médecin
        for (const specialty of doctorSpecialties) {
          const existingAppointments = await fetchExistingAppointments(doctor._id);
          const availableSlots = getAvailableSlotsForDoctor(
            doctorScheduleData,
            specialty,
            doctor,
            existingAppointments
          );

          // Regrouper les créneaux par date
          availableSlots.forEach(slot => {
            const dateStr = slot.date;
            if (!availableDates.has(dateStr)) {
              availableDates.set(dateStr, []);
            }
            availableDates.get(dateStr).push(slot);
          });
        }

        // Créer les événements de calendrier pour les dates disponibles
        const events = generateAvailabilityEvents(
          availableDates, 
          false, 
          isEditing, 
          appointmentInfo.appointmentData.appointmentDate
        );

        setCalendarEvents(events);
        setDoctorScheduleData(doctorScheduleData);
        setSpecialties(doctorSpecialties);
      }
      setIsLoadingAvailability(false);
    } catch (error) {
      console.error('Error fetching doctor availability:', error);
      toast.error('Error loading doctor availability data');
      setIsLoadingAvailability(false);
    }
  };

  const handleSpecialtySelection = (specialty) => {
    setSelectedSpecialty(specialty);
    setSelectedEvent(null); // Reset selected event when specialty changes
  };

  const handleDateChange = (date) => {
    setAppointmentDate(date);
  };

  const calculateEndTime = (startTime, durationInMinutes) => {
    const start = new Date(`1970-01-01T${startTime}:00Z`);
    const end = new Date(start.getTime() + durationInMinutes * 60000);
    const endTime = end.toISOString().substr(11, 5);
    return endTime;
  };

  const handleEventClick = (info) => {
    const { event } = info;

    // Reset any previously selected events
    const allEvents = document.querySelectorAll('.fc-event');
    allEvents.forEach(el => el.style.border = '');

    // Store the selected event details
    setSelectedEvent({
      date: event.extendedProps.date,
      time: event.extendedProps.time,
      durationApt: event.extendedProps.durationApt,
      type: event.extendedProps.type === 'emergency' ? 'camera' : 'person',
      specialtyId: event.extendedProps.specialtyId,
      specialtyName: event.extendedProps.specialtyName,
      allowDoubleBooking: event.extendedProps.allowDoubleBooking || false
    });

    // Visual feedback
    info.el.style.border = '2px solid #007bff';
  };

  // Handler for appointment type selection
  const handleAppointmentTypeChange = (selectedOption) => {
    setAppointmentType(selectedOption.value);
  };

  const handleConfirmAppointment = async () => {
    if (!selectedEvent) {
      toast.error('Please select a time slot.');
      return;
    }

    // console.log("MArche",((userRole !== "medtinz_client_receptionnist" || userRole !== "medtinz_client_doctor" || userRole !== "medtinz_client_master")))
    // if (selectedEvent.allowDoubleBooking && (userRole !== "medtinz_client_receptionnist" && userRole !== "medtinz_client_doctor" && userRole !== "medtinz_client_master")) {
    //   console.log("PSD")
    //   toast.error('You cannot book these slots.');
    //   return;
    // }

    const appointmentData = {
      doctorId: selectedEvent.doctorId,
      patientId: appointmentInfo.appointmentData.patientId,
      motif: appointmentInfo.appointmentData.motif,
      department: appointmentInfo.appointmentData.department,
      price: appointmentInfo.appointmentData.price,
      notes: appointmentInfo.appointmentData.notes,
      type_consultation: appointmentType,
      appointmentDate: selectedEvent.date,
      appointmentTime: selectedEvent.time,
      appointmentEndTime: selectedEvent.endTime,
      specialtyId: selectedEvent.specialtyId,
      specialtyName: selectedEvent.specialtyName
    }

    const dataAppointment = {
      hospitalId,
      appointmentData
    };

    try {
      if (isEditing) {
        const currentTime = new Date();
        const appointmentTime = new Date(appointmentData.appointmentDate);

        // Calculer la différence en heures
        const hoursDifference = (appointmentTime - currentTime) / (1000 * 60 * 60);
        if (hoursDifference < systemSettings.minimumModificationHours && userRole === "medtinz_client_patient") {
          // Calculer le montant de la pénalité
          const appointmentPrice = appointmentData.price || 0;
          const calculatedPenalty = (appointmentPrice * systemSettings.modificationPenaltyPercentage) / 100;
          setPenaltyAmount(calculatedPenalty);
          setShowPenaltyWarningModal(true);
          return; // Arrêter le processus de soumission jusqu'à ce que la pénalité soit confirmée
        } else {
          const response = await api.put(`/clinic/updateappointments/${appointmentInfo.appointmentData._id}`, dataAppointment);
          // setAppointmentInfo(response.data.appointment);

          // Si le prix a changé, mettre à jour le paiement
          // if (appointmentData.price !== appointmentInfo?.appointmentData.price) {
          //     const paymentData = {
          //         OperationId: response.data.appointment._id,
          //         operationtype: 'Appointment Consultation Update',
          //         operationcode: response.data.appointment.AppointmentCode,
          //         paymentuniqueId: response.data.appointment.paymentuniqueId,
          //         caissiereId: getUserIdFromToken(),
          //         patientId: appointmentData.patientId,
          //         amount: appointmentData.price,
          //         currency: 'FCFA',
          //         purpose: 'Consultation Fee Update',
          //         department: appointmentData.department,
          //     };

          //     const paymentResponse = await api.post('/clinic/updatePayment', paymentData);
          //     const billingID = paymentResponse.data.billing._id;

          //     // Rediriger vers la facture si le patient est connecté
          //     if (userRole === "medtinz_client_patient" && billingID) {
          //         navigate(`/Billings/invoiceAssurance/${billingID}`, {
          //             state: { billingID },
          //         });
          //     } else {
          //         setShowSuccessModal(true);
          //     }
          // } else {
          setShowSuccessModal(true);
          toast.success("Rendez-vous mis à jour avec succès");
          // if (onAppointmentUpdated) {
          //     onAppointmentUpdated(response.data.appointment);
          // }
          // }
        }
      } else {
        const response = await api.post('/clinic/createBaseAppointment', dataAppointment);
        setAppointmentFinalInfo(response.data.appointment);

        const paymentData = {
          operationtype: 'Appointment Consultation',
          OperationId: response.data.appointment._id,
          operationRef: "Appointment",
          operationcode: response.data.appointment.AppointmentCode,
          caissiereId: getUserIdFromToken(),
          patientId: response.data.appointment.patientId,
          amount: response.data.appointment.price,
          currency: 'FCFA',
          purpose: 'Consultation Fee',
          department: response.data.appointment.department,
          hospitalId: response.data.appointment.hospitalId,
        };

        const paymentResponse = await api.post('/clinic/createPayment', paymentData);
        setBillingdata(paymentResponse.data.billing);

        const billingID = paymentResponse.data.billing._id;

        if (userRole === "medtinz_client_patient" && billingID) {
          navigate(`/Billings/invoiceAssurance/${billingID}`, {
            state: { billingID },
          });
        } else {
          setShowSuccessModal(true);
        }
      }
    } catch (error) {
      console.error('Error adding appointment:', error);
      toast.error('Failed to add appointment');
    }
  };

  const handleCloseSuccessModal = () => {
    navigate('/hospitaladmin/Appointmentlist');
  };

  return (
    <CModal className='newregistermodal xl'
      alignment="center"
      scrollable
      size='xl'
      visible={true}
      onClose={onClose}
      aria-labelledby="schedulemodal">
      <CModalHeader>
        <CModalTitle id="schedulemodal" className='Titleformsmodal'>{isEditing ? "Modify Appointment" : "Register New Appointment"}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <div className='doctorselect'>
          <div className="retourbtn">
            <CButton className="retourbtn" onClick={() => (navigate(-1) || navigate('/'))}>
              <FaArrowLeft /> Retour
            </CButton>
          </div>
          {doctorMessage && <p>{doctorMessage}</p>}
          <DoctorSelectionSection />

          {/* {selectedDoctor && !showAllDoctors && specialties.length > 0 ? (
    <div className="form-group mb-4">
        <label htmlFor="specialty">Specialty</label>
        <Select
            name="specialtyId"
            options={specialties.map((specialty) => ({
                value: specialty.id,
                label: `${specialty.name} (${specialty.duration} min)`
            }))}
            value={selectedSpecialty ? { 
                value: selectedSpecialty.id, 
                label: `${selectedSpecialty.name} (${selectedSpecialty.duration} min)` 
            } : null}
            onChange={(selectedOption) => {
                const specialty = specialties.find(s => s.id === selectedOption.value);
                handleSpecialtySelection(specialty);
            }}
            placeholder="Select a specialty"
        />
    </div>
) : null} */}

          {/* Added appointment type selection */}
          <div className="form-group mb-4">
            <label htmlFor="appointmentType">Appointment Type</label>
            <Select
              name="appointmentType"
              options={appointmentTypeOptions}
              value={appointmentTypeOptions.find(option => option.value === appointmentType)}
              onChange={handleAppointmentTypeChange}
              placeholder="Select appointment type"
            />
          </div>

          {((selectedDoctor) || showAllDoctors) && (
            <div>
              <p className="mb-3">
                {showAllDoctors ? (
                  <strong>Showing all available appointment slots</strong>
                ) : (
                  <>
                    <strong>Dr. {selectedDoctor.lastname} {selectedDoctor.firstname}</strong> available appointments
                  </>
                )}
              </p>

              <CalendarComponent />

              {selectedEvent && (
                <div className="selected-slot mb-4 p-3 border rounded bg-light">
                  <h5>Selected appointment slot:</h5>
                  <p><strong>Date:</strong> {new Date(selectedEvent.date).toLocaleDateString()}</p>
                  <p><strong>Time:</strong> {selectedEvent.time}</p>
                  {showAllDoctors && (
                    <p><strong>Doctor:</strong> Dr. {selectedEvent.doctorLastname} {selectedEvent.doctorFirstname}</p>
                  )}
                  <p><strong>Specialty:</strong> {selectedEvent.specialtyName}</p>
                  <p><strong>Duration:</strong> {selectedEvent.durationApt} minutes</p>
                  <p><strong>Appointment Type:</strong> {appointmentType === 'online' ? 'Video consultation' : 'In-person visit'}</p>
                  {selectedEvent.isEmergency && (
                    <p className="text-danger"><strong>Emergency Slot</strong></p>
                  )}
                  {selectedEvent.isAlreadyBooked && selectedEvent.allowDoubleBooking && (
                    <p className="text-info"><strong>Note:</strong> This slot is already booked but allows double-booking</p>
                  )}

                  <CButton
                    color="primary"
                    onClick={handleConfirmAppointment}
                    className="mt-2"
                  >
                    Confirm Appointment
                  </CButton>
                </div>
              )}

              {calendarEvents.length === 0 && (
                <div className="alert alert-warning">
                  No availability found. Please try another selection.
                </div>
              )}
            </div>
          )}
        </div>
      </CModalBody>

      <div className='timetablelast'>
        {showSuccessModal && (
          <div className="modal-overlay">
            <div className="modal-content2">
              <div className="text-center vie">
                <h2 className="text-lg semibold mb-4">SUCCESS</h2>
              </div>

              <div className="immole">
                {!isEditing ? (<div className="text-start">
                  <p><strong>Rdv Enregistré avec succès</strong> </p>
                  <p>Veuillez passer à la caisse avec ce numéro<strong style={{ color: 'green' }}> {billingdata?.paymentuniqueId}</strong> pour effectuer votre paiement</p>
                  <p><strong>Appointment Code:</strong> {appointmentFinalInfo?.AppointmentCode}</p>
                  <p><strong>Patient ID:</strong> {appointmentFinalInfo?.patient_Name}</p>
                  {/* <p><strong>Specialty:</strong> {appointmentFinalInfo?.specialtyName || 'N/A'}</p> */}
                  <p><strong>Motif:</strong> {appointmentFinalInfo?.motif}</p>
                  <p><strong>Type Consultation:</strong> {appointmentFinalInfo?.type_consultation}</p>
                  <p><strong>Department:</strong> {
                    departments.find(department => department._id === appointmentFinalInfo?.department)?.name || 'N/A'
                  }</p>
                  <p><strong>Price:</strong> {appointmentFinalInfo?.price} FCFA</p>
                  <p><strong>Notes:</strong> {appointmentFinalInfo?.notes}</p>
                </div>) : (<div className="text-start">
                  <p><strong>Rdv Modifier avec succès</strong> </p>
                  {/* <p>Veuillez passer à la caisse avec ce numéro<strong style={{ color: 'green' }}> {appointmentFinalInfo?.paymentuniqueId}</strong> pour effectuer votre paiement</p> */}
                  {/* <p><strong>Appointment Code:</strong> {appointmentFinalInfo?.AppointmentCode}</p> */}
                  {/* <p><strong>Patient ID:</strong> {appointmentFinalInfo?.patient_Name}</p> */}
                  {/* <p><strong>Specialty:</strong> {appointmentFinalInfo?.specialtyName || 'N/A'}</p> */}
                  {/* <p><strong>Motif:</strong> {appointmentFinalInfo?.motif}</p> */}
                  {/* <p><strong>Type Consultation:</strong> {appointmentFinalInfo?.type_consultation}</p> */}
                  {/* <p><strong>Department:</strong> {
                                        departments.find(department => department._id === appointmentFinalInfo?.department)?.name || 'N/A'
                                    }</p> */}
                  {/* <p><strong>Price:</strong> {appointmentFinalInfo?.price} FCFA</p>
                                    <p><strong>Notes:</strong> {appointmentFinalInfo?.notes}</p> */}
                </div>)}
                <div>
                  <img src={choco} alt="choco" className="choco" />
                </div>
              </div>

              <div className="mt-4">
                <button
                  className="modal-button2 confirm mx-auto"
                  onClick={handleCloseSuccessModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Modal d'avertissement de pénalité */}
      <CModal visible={showPenaltyWarningModal} onClose={() => setShowPenaltyWarningModal(false)}>
        <CModalHeader closeButton>
          <h5>Late Modification Warning</h5>
        </CModalHeader>
        <CModalBody>
          <div className="alert alert-warning">
            <p><strong>Warning:</strong> You are modifying this appointment less than {systemSettings.minimumModificationHours} hours before the scheduled time.</p>
            <p>A modification penalty of {systemSettings.modificationPenaltyPercentage}% will be applied.</p>
            <p>Estimated penalty amount: {penaltyAmount.toFixed(2)}</p>
          </div>
          <p>Do you wish to proceed with the modification?</p>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setShowPenaltyWarningModal(false)}>
            No, Keep Original Appointment
          </CButton>
          <CButton color="warning" onClick={()=> handleConfirmModificationWithPenalty()}>
            Confirm and Accept Penalty1
          </CButton>
        </CModalFooter>
      </CModal>

      {/* Modal de paiement */}
      {/* <CModal visible={showPaymentModal} onClose={() => setShowPaymentModal(false)} className="payment-gateway-modal">
        <CModalHeader closeButton className="modal-header1">
          <h5>Paiement</h5>
        </CModalHeader>
        <CModalBody className="p-0">
          <div className="ret">
            <button
              className="payment-gateway-modal-close"
              onClick={() => setShowPaymentModal(false)}
            >
              ← Retour
            </button>
            <div className="paycontent">
              <div className="alert alert-info mb-4">
                <p>Pour modifier ce rendez-vous, vous devez d'abord payer la pénalité de modification de {penaltyAmount.toFixed(2)}.</p>
              </div>

              <h2 className="pinta">Choisissez votre méthode de paiement</h2>
              <div className="payment-method-selection">
                <label className="payment-method-radio">
                  <input
                    type="radio"
                    name="payment-method"
                    value="mobile-money"
                    checked={paymentMethod === 'mobile-money'}
                    onChange={() => handlePaymentMethodSelect('mobile-money')}
                  />
                  <img src={monday} alt="Mobile Money" className="monday" />
                </label>
                <label className="payment-method-radio">
                  <input
                    type="radio"
                    name="payment-method"
                    value="card"
                    checked={paymentMethod === 'card'}
                    onChange={() => handlePaymentMethodSelect('card')}
                  />
                  <img src={money} alt="Card Payment" className="money" />
                </label>
              </div>

              {paymentMethod === 'mobile-money' && (
                <div className="phone-input-container mobile-money-input">
                  <label>Entrez votre numéro de téléphone</label>
                  <PhoneInput
                    country={'bj'}
                    value={phone}
                    onChange={(value) => setPhoneNumber(value)}
                    name="phone"
                    className="mx-auto"
                  />
                </div>
              )}

              {paymentMethod === 'card' && (
                <>
                  <div className="mb-3">
                    <label className="form-label">Numéro de carte</label>
                    <CFormInput
                      type="text"
                      placeholder="XXXX XXXX XXXX XXXX"
                      value={cardNumber}
                      onChange={(e) => setCardNumber(e.target.value)}
                    />
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Date d'expiration</label>
                      <CFormInput
                        type="text"
                        placeholder="MM/YY"
                        value={cardExpiry}
                        onChange={(e) => setCardExpiry(e.target.value)}
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label">CVC</label>
                      <CFormInput
                        type="text"
                        placeholder="123"
                        value={cardCVC}
                        onChange={(e) => setCardCVC(e.target.value)}
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="aladji">
                <button
                  onClick={paymentMethod === 'mobile-money' ? handleMomoPaymentConfirmation : handleMomoPaymentConfirmation}
                  disabled={(paymentMethod === 'mobile-money' && !phone) || isProcessingPayment}
                  className="payment-confirm-button"
                >
                  {isProcessingPayment ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Traitement...
                    </>
                  ) : (
                    `Confirmer le Paiement (${penaltyAmount.toFixed(2)})`
                  )}
                </button>
                <p className="vonvon">
                  Vos données personnelles seront utilisées pour traiter votre commande, soutenir votre<br></br>
                  expérience sur ce site Web et à d'autres fins décrites<br></br>
                  dans notre politique de confidentialité.
                </p>
              </div>
            </div>
          </div>
        </CModalBody>
      </CModal> */}
    </CModal>
  );
};

export default DoctorSelectionrdv;